/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */

import { isEmptyField } from "./validators/isEmptyField";
export function checkValidityOfSettingsField(
  value?: any,
  errorMessage?: any,
  rules?: any,
  required: boolean = false
) {
  // Respect the metadata required flag. Optional fields may be empty.
  if (required && isEmptyField(value)) {
    return false;
  }

  if (!required && isEmptyField(value)) {
    return true;
  }

  if (rules?.length === 0) {
    return true;
  } else if (
    value !== undefined &&
    value !== "" &&
    (errorMessage === undefined || errorMessage === "")
  ) {
    return true;
  }
  return false;
}
